import React, { useState } from 'react';

import { getRandomString } from 'utils/';
import {
  StyledBody,
  StyledInput,
  StyledButton,
  StyledDetail,
  StyledFormGroup,
  StyledSrOnlyLabel,
} from 'components/Order/ItemSKU/ItemSKU.styled';

function ItemSKU({ onSubmit }) {
  const [sku, setSKU] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  function onGenerateSKU() {
    setIsSubmitting(true);
    const sku = getRandomString({ length: 13, prefix: 'W-', upperCase: true });
    setSKU(sku);
    onSubmit(sku);
  }

  return (
    <StyledBody>
      <StyledDetail>
        This item has no SKU which is needed in order to return item to a
        different warehouse. Would you like an SKU to be auto-generated?
      </StyledDetail>
      <StyledFormGroup>
        <StyledSrOnlyLabel htmlFor="sku">Item SKU</StyledSrOnlyLabel>
        <StyledInput
          id="sku"
          disabled
          type="sku"
          value={sku}
          placeholder="e.g W-GBQCKXR1ENZTBCIBGRIW"
        />
        <StyledButton disabled={isSubmitting} onClick={onGenerateSKU}>
          Generate
        </StyledButton>
      </StyledFormGroup>
    </StyledBody>
  );
}

export default ItemSKU;
